<template>
  <v-dialog
    overlay-color="grey darken-2"
    transition="scroll-x-transition"
    v-model="dialog"
    max-width="700"
    content-class="overflowY-hidden"
    persistent
  >
    <v-card width="700px" class="accent">
      <v-card-title
        style="background-color: #47bd96; color: white"
        :style="
          $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
        "
        class="pageTitle"
        >Edit Chart</v-card-title
      >
      <div class="pa-4">
        <v-row no-gutters>
          <v-col>
            <v-text-field
                v-model="chartConfigurations.name"
                dense
                outlined
                label="Chart Name"
                class="mt-2"
                style="width: 300px"
                :disabled="!canAlter"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
                v-model="chartConfigurations.symbols"
                :disabled="(chartConfigurations.type !== VISUALIZATION_TYPES.CHART) || !canAlter"
                :items="symbols"
                no-data-text="No common symbols in selected watchers"
                dense
                outlined
                label="Symbol"
                class="mt-2"
                style="width: 300px"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-select
                dense
                outlined
                v-model="chartConfigurations.watchers"
                :items="watchers"
                :disabled="!canAlter"
                @change="recalculateSymbols"
                :menu-props="{ offsetY: true, maxHeight: '250' }"
                label="Watchers"
                item-text="name"
                item-value="id"
                multiple
                class="mt-2"
                style="width: 300px"
            >
              <template v-slot:item="{ item }">
                <div class="mb-0 char-lim-tabs">
                  <div>{{ item.name }}</div>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1">
                  (+{{ chartConfigurations.watchers.length - 1 }}
                  others)
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item
                  style="max-height: 40px; border-bottom: 1px solid #7f7f7f"
                  ripple
                  @click="selectAllWatchers"
                >
                  <v-list-item-content>
                    <v-list-item-title
                        :class="
                        chartConfigurations.watchers.length === watchers.length
                          ? 'primary--text'
                          : $vuetify.theme.dark
                          ? 'white--text'
                          : 'black--text'
                      "
                        style="font-size: 16px !important; font-weight: 400"
                    >{{ chartConfigurations.watchers.length === watchers.length ? 'Deselect All' : 'Select All' }}
                    </v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col>
            <!--            <v-checkbox-->
            <!--                v-model="chartConfigurations.isPublic"-->
            <!--                :label="`Is Public: ${chartConfigurations.isPublic ? 'Yes' : 'No'}`"-->
            <!--                off-icon="check_box_outline_blank"-->
            <!--                on-icon="check_box"-->
            <!--                hint="Specify if the chart will be available to regular users or only Admin"-->
            <!--                class="is-public-checkbox"-->
            <!--            />-->
            <input-wrapper v-if="isAdmin" label="Visibility">
              <v-switch
                  v-model="chartConfigurations.isPublic"
                  :label="`${chartConfigurations.isPublic ? 'Public' : 'Private'}`"
                  hide-details
                  dense
                  :disabled="!canAlter"
              />
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">fa fa-info-circle</v-icon>
                </template>
                <span>Specify if the chart will also be visible to regular users or only to Admin and to the owner of the chart</span>
              </v-tooltip>
            </input-wrapper>
          </v-col>
        </v-row>

        <!-- <v-row no-gutters class="mb-4 ml-4"> Type </v-row>

        <v-row no-gutters>
          <v-col sm="4" cols="12">
            <v-row no-gutters justify="center">
              <v-icon
                x-small
                :class="{
                  'primary--text': chartConfigurations.type == chartTypes.chart,
                }"
                class="mr-1"
                >fas fa-chart-line</v-icon
              >
              <p
                :class="{
                  'primary--text': chartConfigurations.type == chartTypes.chart,
                }"
                class="text-center mb-0"
              >
                Chart
              </p>
            </v-row>
            <v-btn
              @click="chartConfigurations.type = chartTypes.chart"
              text
              height="120"
            >
              <v-img
                src="../../assets/views-images/pricewatcher/chart.png"
                :aspect-ratio="18 / 9"
                width="185"
              ></v-img>
              <i
                v-if="chartConfigurations.type == chartTypes.chart"
                class="primary--text fas fa-check-circle"
                style="position: absolute; font-size: 26px"
              ></i>
            </v-btn>
          </v-col>
          <v-col sm="4" cols="12">
            <v-row no-gutters justify="center">
              <v-icon
                x-small
                :class="{
                  'primary--text': chartConfigurations.type == chartTypes.table,
                }"
                class="mr-1"
                >fa-solid fa-clock-rotate-left</v-icon
              >
              <p
                :class="{
                  'primary--text': chartConfigurations.type == chartTypes.table,
                }"
                class="text-center mb-0"
              >
                Historical Table
              </p>
            </v-row>
            <v-row justify="center">
              <v-btn
                @click="chartConfigurations.type = chartTypes.table"
                text
                height="120"
                class="px-6"
                stle="width:150px !important;"
              >
                <v-row justify="center">
                  <v-img
                    src="../../assets/views-images/pricewatcher/table.png"
                    :aspect-ratio="13 / 9"
                    width="140"
                  ></v-img>
                </v-row>
                <i
                  v-if="chartConfigurations.type == chartTypes.table"
                  class="primary--text fas fa-check-circle"
                  style="position: absolute; font-size: 26px"
                ></i>
              </v-btn>
            </v-row>
          </v-col>
          <v-col sm="4" cols="12">
            <v-row no-gutters justify="center">
              <v-icon
                x-small
                :class="{
                  'primary--text':
                    chartConfigurations.type == chartTypes.liveTable,
                }"
                class="mr-1"
                >fas fa-broadcast-tower</v-icon
              >
              <p
                :class="{
                  'primary--text':
                    chartConfigurations.type == chartTypes.liveTable,
                }"
                class="text-center mb-0"
              >
                Live Table
              </p>
            </v-row>
            <v-btn
              @click="chartConfigurations.type = chartTypes.liveTable"
              text
              height="120"
              class="px-2"
            >
              <v-img
                src="../../assets/views-images/pricewatcher/table_live.png"
                :aspect-ratio="18 / 9"
                width="185"
              ></v-img>
              <i
                v-if="chartConfigurations.type == chartTypes.liveTable"
                class="primary--text fas fa-check-circle"
                style="position: absolute; font-size: 26px"
              ></i>
            </v-btn>
          </v-col>
        </v-row> -->
      </div>
      <v-row class="mx-0 accent" justify="space-between">
        <v-btn class="ma-2 opacity-1-slow" text @click="dialog = false"
        >Cancel
        </v-btn
        >
        <v-spacer></v-spacer>
        <div @click="save">
          <v-btn
              :disabled="(chartConfigurations.symbols == null) || !canAlter"
              :disable="(chartConfigurations.symbols == null) || !canAlter"
              class="ma-2 opacity-1-slow" color="primary"
          >
            Save
          </v-btn>
        </div>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {VISUALIZATION_TYPES} from "@/utilities/enums";
import InputWrapper from '@/components/UI/InputWrapper.vue';
import {mapGetters} from "vuex";
import {cloneDeep} from "lodash";

export default {
  name: "ChartConfiguration",
  data: () => ({
    configurationsOfCurrentWatchers: {},
    tempWatchers: [],
    VISUALIZATION_TYPES: VISUALIZATION_TYPES,
    chartConfigurations: {},
    chartTypes: {
      chart: 0,
      table: 1,
      liveTable: 2,
    },
    symbols: [],
    isPublic: false,
  }),
  components: {InputWrapper},
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    configuration: {
      type: Object,
      default: () => {
      },
    },
    watchers: {
      type: Array,
      default: () => [],
    },
    definitions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getCurrentWatchers() {
      let watchers = {};

      this.configuration.watchers.forEach((watcherID) => {
        if (!watchers.hasOwnProperty(watcherID)) {
          watchers[watcherID] = this.getConfiguration(watcherID);
        }
      });

      return watchers;
    },
    getCommonSymbols() {
      // If there are no watchers sellected then the common symbols are none
      if(!this.chartConfigurations.watchers.length) return []
      
      let currentWatchersLength = Object.keys(
        this.configurationsOfCurrentWatchers
      ).length;
      if (!currentWatchersLength) {
        this.configurationsOfCurrentWatchers = this.getCurrentWatchers();
      }
      let firstConfigurationKey = this.chartConfigurations.watchers[0];

      let commonSymbols =
        this.configurationsOfCurrentWatchers[firstConfigurationKey]
          .watched_symbols;

      // if(commonSymbols.length && typeof commonSymbols[0] == 'object') {
      //   commonSymbols = commonSymbols.map(el => el.name)
      // }

      this.chartConfigurations.watchers.forEach((watcherID, index) => {
        if(index === 0) return
        commonSymbols = this.mergeCommonSymbolArrays(
          commonSymbols,
          this.configurationsOfCurrentWatchers[watcherID].watched_symbols
        );
      });

      return commonSymbols;
    },
    mergeCommonSymbolArrays(mainArray, secondaryArary) {
      return mainArray.filter((el) =>
        secondaryArary.some((item) => item === el)
      );
    },
    getFullIdentity(definition) {
      let stringID = definition.id.toString();
      let numberOfDigits = stringID.length;
      switch (numberOfDigits) {
        case 1:
          stringID = "00" + stringID;
          break;
        case 2:
          stringID = "0" + stringID;
          break;
      }

      return definition.application.code + stringID;
    },
    getConfiguration(identity) {
      let config = this.definitions.find(
        (el) => this.getFullIdentity(el) === identity
      );
      let definition = config.configuration

      // DESCRIPTION:
      // Convert all symbol objects to strings (in all watcher definitions)
      // e.g {name: "XAUUSD", alias: "GOLD"} => "GOLD"
      if(definition.watched_symbols && definition.watched_symbols.length && typeof definition.watched_symbols[0] == "object") {
        definition.watched_symbols = definition.watched_symbols.map(el => el.hasOwnProperty('alias') ? el.alias : el.name)
      }

      return config.configuration;
    },
    recalculateSymbols(watchersIDs) {
      // if configurationsOfCurrentWatchers doesnt have this watcher then add it
      watchersIDs.forEach((watcherID) => {
        if (!this.configurationsOfCurrentWatchers.hasOwnProperty(watcherID)) {
          this.configurationsOfCurrentWatchers[watcherID] =
            this.getConfiguration(watcherID);
        }
      });

      // Next ->
      // Recalculate the common symbols of the selected watchers
      // and update the  this.symbols (+ might need to nullify the chartConfigurations.symbols)
      // let firstConfigurationKey = Object.keys(this.configurationsOfCurrentWatchers)[0]
      // let commonSymbols = this.configurationsOfCurrentWatchers[firstConfigurationKey].watched_symbols
      this.symbols = this.getCommonSymbols();

      if (!this.symbols.includes(this.chartConfigurations.symbols)) {
        this.chartConfigurations.symbols = null;
      }

    },
    selectAllWatchers() {
      if (this.chartConfigurations.watchers.length === this.watchers.length)
        this.chartConfigurations.watchers = [];
      else this.chartConfigurations.watchers = this.watchers.map((el) => el);
    },
    clearDialog() {},
    save() {
      // TODO:
      // Figure out the symbols & watchers UI
      // Some watchers might not have same symbols
      // So it has to be either:
      // - Select a symbol and then select from watchers watching that symbol
      // - Or Select watcher(s) and then select a symbol from a list of
      // symbols where each symbol is watched by all of the watchers selected above

      // Saving process:
      // 1. Update the Configuration of the watcher
      // 2. Send the "sets symbols to track" command to the watcher, so it updates
      // 3. Save the necessary chart info (like type)
      const clonedConfigurationsData = cloneDeep(this.chartConfigurations);
      this.$emit("save", JSON.parse(JSON.stringify(clonedConfigurationsData)));
      // this.$emit("save", JSON.parse(JSON.stringify(this.chartConfigurations)));

      // this.chartConfigurations = JSON.parse(JSON.stringify(defaultChart));
      // this.dialog = false;
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "isAdmin"]),
    canAlter() {
      return ((this.isAdmin === true) || (this.chartConfigurations.owner === this.getUserInfo.name));
    },
    dialog: {
      get() {
        return this.value;
      },
      set(ev) {
        this.$emit("input", ev);
      },
    },
  },
  watch: {
    dialog(v) {
      if (!v) this.clearDialog();
      else {
        // Set the value for the edit fields

        // TODO
        // Before doing this, remove the watchers in this.configuration
        // that do not exist in this.watchers
        // Because those watchers have been terminated.
        this.chartConfigurations = JSON.parse(
            JSON.stringify(this.configuration)
        );
        this.symbols = this.getCommonSymbols();
      }
    },
  },
};
</script>
